import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, defineMessages } from 'react-intl';
import { FormLabel } from '@material-ui/core';

import StrongText from '../styles/StrongText';
import List from '../List';

defineMessages({
    fabricMaterialLabel: {
        id: 'FABRIC_MATERIAL_LABEL',
        description: 'Label of the fabric material',
        defaultMessage: 'Material',
    },
    patternTitleLabel: {
        id: 'PATTERN_TITEL_LABEL',
        description: 'Label of the pattern title e.g. in selected values overview.',
        defaultMessage: 'Stoff',
    },
    fabricTitleLabel: {
        id: 'FABRIC_TITLE_LABEL',
        description: 'Label of the tabric title e.g. in selected values overview.',
        defaultMessage: 'Stoffqualität',
    },
    fabricLengthLabel: {
        id: 'FABRIC_LENGTH_LABEL',
        description: 'Label of the fabric length title e.g. in selected values overview.',
        defaultMessage: 'Stoffmenge',
    },
});

const SelectedValueLegend = (
    <FormattedMessage
        id='FABRIC_SELECTED_VALUE_LEGEND'
        description='Label of the selected values form element.'
        defaultMessage='Aktuelle Auswahl'
    />
);
const Slogan = (
    <FormattedMessage
        key='222'
        id='SCHEMA_SLOGAN_LANG'
        description='Slogan we appand to schema org product titles.'
        defaultMessage='Näh Dir Dein Designerstück, so individuell wie Du selbst. Mit Stoffen aus Berlin, einfärbbar in Deinen Wunschfarben.'
    />
);

const SelectedValues = props => {
    const StyledThing = styled.ul`
        list-style-type: circle;
        margin: 0;
        padding: 0 ${props => props.theme.space[8]};
        
        & li {
          padding: ${props => props.theme.space[1]} 0;
        }
    `;

    const Wrapper = props.wrapper.extend`
        max-width: 22rem;
        flex-grow: 2;
        
        & .stolo-hidden {
         display: none;
        }
    `;

    const selectedValues = () => {
        const items = [];
        Object.keys(props.values).map((label, index) => {
            items.push([
                <StrongText key={label}>{label}: </StrongText>,
                props.values[label]]);
        });
        return items;
    };

    const name = `${props.fabricTitle}: ${props.patternTitle}`;
    const description = [`${props.fabricTitle}: ${props.patternTitle} `, Slogan];

    return (
        <Wrapper className='stolo-cart-item' >
            <FormLabel key='20' component='legend' >{SelectedValueLegend}</FormLabel >
            <List key='24' items={selectedValues()} />
            <meta key='21' itemProp='name' content={name} />
            <span
                key='22' className='stolo-hidden'
                itemProp='description'
            >{description}</span >
        </Wrapper >
    );
};

export default SelectedValues;



// WEBPACK FOOTER //
// ./src/components/addtocart/SelectedValues.js